import React from "react";
import ReportResultsTable from "../shared/ReportResultsTable";

function OpportunityPipelineReportBuilder({
  carriers,
  carriersLoading,
  coverageTypes,
  coverageTypesLoading,
  opportunityStatuses,
  opportunityStatusesLoading,
  filters,
  setFilters,
  reportResults,
  builtConfig,
  formatFieldName
}) {
  const updateFilter = (field, value) => {
    setFilters((prev) => {
      const next = [...prev];
      const index = next.findIndex((item) => item.field === field);

      if (value === "" || value == null) {
        if (index >= 0) next.splice(index, 1);
        return next;
      }

      const filter = {
        field,
        operator: "equals",
        value,
        value2: ""
      };

      if (index >= 0) {
        next[index] = filter;
      } else {
        next.push(filter);
      }

      return next;
    });
  };

  const getFilterValue = (field) => {
    const found = filters.find((item) => item.field === field);
    return found?.value || "";
  };

  const handleClearFilters = () => {
    setFilters([]);
  };

  const selectedColumns = reportResults?.selectedColumns || builtConfig.selectedColumns || [];
  const rows = reportResults?.rows || [];
  const subtitle = reportResults
    ? `${reportResults.rowCount} row${reportResults.rowCount === 1 ? "" : "s"}`
    : "Run the report to view pipeline opportunities";

  const getColumnStyle = (column) => {
    if (column === "premium") {
      return {
        width: "120px",
        minWidth: "120px",
        whiteSpace: "nowrap"
      };
    }

    return undefined;
  };

  const toolbar = (
    <div className="sales-toolbar-card" style={{ marginBottom: "14px" }}>
      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          alignItems: "center"
        }}
      >
        <select
          value={getFilterValue("status")}
          onChange={(e) => updateFilter("status", e.target.value)}
          className="sales-search-input"
          disabled={opportunityStatusesLoading}
          style={{ maxWidth: "220px" }}
        >
          <option value="">All Open Statuses</option>
          {opportunityStatuses.map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </select>

        <select
          value={getFilterValue("carrier_id")}
          onChange={(e) => updateFilter("carrier_id", e.target.value)}
          className="sales-search-input"
          disabled={carriersLoading}
          style={{ maxWidth: "220px" }}
        >
          <option value="">All Carriers</option>
          {carriers.map((carrier) => (
            <option key={carrier.id} value={carrier.id}>
              {carrier.name || carrier.carrier_name}
            </option>
          ))}
        </select>

        <select
          value={getFilterValue("coverage_type_id")}
          onChange={(e) => updateFilter("coverage_type_id", e.target.value)}
          className="sales-search-input"
          disabled={coverageTypesLoading}
          style={{ maxWidth: "220px" }}
        >
          <option value="">All Coverage Types</option>
          {coverageTypes.map((coverageType) => (
            <option key={coverageType.id} value={coverageType.id}>
              {coverageType.name}
            </option>
          ))}
        </select>

        <button
          type="button"
          className="sales-secondary-btn"
          onClick={handleClearFilters}
        >
          Clear Filters
        </button>
      </div>
    </div>
  );

  return (
    <>
      <div className="sales-section-card">
        <div className="sales-section-head">
          <h2>Opportunity Pipeline Criteria</h2>
          <p>
            Review open opportunities using status, coverage type, and carrier filters.
          </p>
        </div>
      </div>

      <div style={{ marginTop: "10px" }}>
        <ReportResultsTable
          title="Report Results"
          subtitle={subtitle}
          selectedColumns={selectedColumns}
          rows={rows}
          emptyMessage={
            reportResults ? "No matching opportunities found." : "Run the report to view results."
          }
          toolbar={toolbar}
          formatFieldName={formatFieldName}
          getColumnStyle={getColumnStyle}
        />
      </div>
    </>
  );
}

export default OpportunityPipelineReportBuilder;